import { DatabaseWrapper } from '../../../shared/databases/database.wrapper';
import { Database } from '../../../shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';

export class HbaseWrapper extends DatabaseWrapper {

    constructor(database: Database) {
        super(database);
        this.dbTyp_Id = DatabaseEnum.hbase.ID;
        this.name = DatabaseEnum.hbase.NAME;
        this.code = DatabaseEnum.hbase.CODE;
        this.equivalentTag = DatabaseEnum.hbase.EQUIVALENT_TAG;
        this.showDatabaseTab = true;
        this.showLoadPropertiesTab = false;
        this.isShowObjProperties = true;
        this.hideSchemaNmColumn = false;
        this.showDDLOption = true;
        this.showViewDataTabOption = true;
        this.dataObjectConnDatabaseNm = 'Database';
        this.showDataDescription = false;
    }

    validateRepConn(repConnWrapper: RepConnWrapper) {
        console.log('factory:: hbaseWrapper:: validateRepConn()::');
        if (repConnWrapper.repConn.conn.host == "" || repConnWrapper.repConn.conn.host == undefined) {
            repConnWrapper.inValid_Cds.push('NO_HOST');
        }
        if (repConnWrapper.repConn.conn.port == "") {
            repConnWrapper.inValid_Cds.push('NO_PORT');
        }
        if (repConnWrapper.repConn.conn.secAuth == "Basic") {
            if (repConnWrapper.repConn.conn_Usr.conn_Usr == "") {
                repConnWrapper.inValid_Cds.push('NO_CONN_APPUSR');
            }
        }

        if (repConnWrapper.repConn.conn.secAuth == "Basic") {
            if (repConnWrapper.repConn.conn_Usr.usrPasswd == "") {
                repConnWrapper.inValid_Cds.push('NO_PASSWORD');
            }
        }

        if (repConnWrapper.repConn.conn.cs_SSL_Flag == "Y") {
            if (repConnWrapper.repConn.conn.ssl_trustStore == "") {
                repConnWrapper.inValid_Cds.push('TRUST_STORE_USER');
            }
            if (repConnWrapper.repConn.conn.ssl_trustStorePassword == "") {
                repConnWrapper.inValid_Cds.push('TRUST_STORE_PASSWORD');
            }
            if (repConnWrapper.repConn.conn.ssl_keyStore == "") {
                repConnWrapper.inValid_Cds.push('KEY_STORE_USER');
            }
            if (repConnWrapper.repConn.conn.ssl_keyStorePassword == "") {
                repConnWrapper.inValid_Cds.push('KEY_STORE_PASSWORD');
            }
        }
        if (repConnWrapper.repConn.conn_Dbs.length != 0) {
            if (repConnWrapper.repConn.conn_Dbs[0].databaseNm == "") {
                repConnWrapper.inValid_Cds.push('NO_DATABASE_NM');
            }
        }
        if (repConnWrapper.repConn.conn.flagent_Id == -1) {
            repConnWrapper.inValid_Cds.push('ESM00202');
        }
    }

    getConn_DbColumns(repConnWrapper: RepConnWrapper, component): Array<any> {
        return [
            this.conn_DbsTabultor.getCheckBoxColumn(repConnWrapper),
            this.conn_DbsTabultor.getSrt_Order(),
            this.conn_DbsTabultor.getName(repConnWrapper),
            this.conn_DbsTabultor.getDatabaseNm(repConnWrapper, component),
            // this.conn_DbsTabultor.getStgDb_Flag(repConnWrapper)
        ]
    }

}
